import { cn } from '@/lib/utils/cn';

export interface LoadingSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Height shorthand — e.g. "h-4", "h-24" */
  lines?: number;
}

export function LoadingSkeleton({ className, lines, ...props }: LoadingSkeletonProps) {
  if (lines && lines > 1) {
    return (
      <div className="space-y-2" {...props}>
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={cn(
              'skeleton rounded-[var(--radius-md)]',
              i === lines - 1 ? 'w-3/4' : 'w-full',
              className ?? 'h-4',
            )}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={cn('skeleton rounded-[var(--radius-md)]', className ?? 'h-4 w-full')}
      aria-hidden="true"
      {...props}
    />
  );
}

export function CardSkeleton() {
  return (
    <div className="bg-[var(--color-bg-secondary)] border border-[var(--color-border)] rounded-[var(--radius-lg)] p-5 space-y-4">
      <div className="flex items-center gap-3">
        <LoadingSkeleton className="w-10 h-10 rounded-full" />
        <div className="flex-1 space-y-2">
          <LoadingSkeleton className="h-4 w-1/2" />
          <LoadingSkeleton className="h-3 w-1/3" />
        </div>
      </div>
      <LoadingSkeleton lines={3} className="h-3" />
    </div>
  );
}

export function TableRowSkeleton({ cols = 5 }: { cols?: number }) {
  return (
    <tr aria-hidden="true">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-4 py-3">
          <LoadingSkeleton className="h-4 w-full" />
        </td>
      ))}
    </tr>
  );
}
